import React from "react";
import {Link} from "react-router-dom";
import {deleteChart, removeDashboardChart, setDashboardChart} from "../../services/ChartService";
import ResidualPlot from "../2AFC/component/residualPlot";
import RawData from "../2AFC/component/rawData";
import DatasetSummary from "../2AFC/component/datasetSummary";
import Heatmap from "../2AFC/component/heatmap";
import ResultsTable from "../2AFC/component/resultsTable";
import PValueMatrix from "../2AFC/component/pValueMatrix";
import Barchart from "../2AFC/component/barchart";
import BarchartQualityScore from "../2AFC/component/barchartQualityScore";
import PairwiseDiagram from "../2AFC/component/pairwiseDiagram";

class PartTwoAfcPanel extends React.Component {
    constructor(props) {
        super(props);

        const id = props.twoAfcData?.id;
        this.state = {
            jwtToken: props.jwtToken,
            twoAfcData: props.twoAfcData,
            showBt: id ? sessionStorage.getItem(`2afc_showBt_${id}`) === "true" : false,
            showTm: id ? sessionStorage.getItem(`2afc_showTm_${id}`) === "true" : false
        };
        // binding
        this.handleDelete = this.handleDelete.bind(this);
        this.addToDashboard = this.addToDashboard.bind(this);
        this.removeFromDashboard = this.removeFromDashboard.bind(this);
        this.updateParent = this.updateParent.bind(this);
    }

    // delete 2AFC
    handleDelete() {
        deleteChart(this.props.jwtToken, this.props.twoAfcData.id)
            .then(response => {
                    if (response.ok) {
                        this.props.showAlert({
                            type: "success",
                            message: "2AFC removed successfully."
                        });
                        this.props.handleUpdate();
                    } else {
                        this.props.showAlert({
                            type: "error",
                            message: "2AFC could not be removed."
                        });
                    }
                }
            );
    }

    updateParent(){
        this.props.handleUpdate();
    }

    // pin to dashboard
    addToDashboard(){
        setDashboardChart(this.state.jwtToken, this.state.twoAfcData.id)
            .then(response =>
                {
                    if (response.ok) {
                        this.props.showAlert({
                            type: "success",
                            message: "2AFC added to dashboard."
                        });
                        this.updateParent();
                    } else {
                        this.props.showAlert({
                            type: "error",
                            message: "2AFC could not be added to dashboard."
                        });
                    }
                }
            );
    }

    // unpin from dashboard
    removeFromDashboard(){
        removeDashboardChart(this.state.jwtToken, this.state.twoAfcData.id)
            .then(response =>
                {
                    if (response.ok) {
                        this.props.showAlert({
                            type: "success",
                            message: "2AFC removed from dashboard."
                        });
                        this.updateParent();
                    } else {
                        this.props.showAlert({
                            type: "error",
                            message: "2AFC could not be removed from dashboard."
                        });
                    }
                }
            );
    }

    render() {
        const CARD = {
            borderRadius: "8px",
            marginBottom: "20px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.10)"
        };
        const CARD_HEADER = {
            background: "#1e293b",
            padding: "10px 16px",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            borderRadius: "8px 8px 0 0"
        };
        const CARD_TITLE = {
            margin: 0,
            color: "white",
            fontSize: "15px",
            fontWeight: "600"
        };
        const SECTION = {
            borderLeft: "1px solid #cbd5e1",
            borderRight: "1px solid #cbd5e1"
        };
        const SECTION_LAST = {
            ...SECTION,
            borderBottom: "1px solid #cbd5e1",
            borderRadius: "0 0 8px 8px"
        };
        const CARD_BODY = {
            padding: "16px 20px",
            background: "white"
        };

        const MODEL_CARD = {
            borderRadius: "8px",
            boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
            flex: "1 1 500px",
            minWidth: 0
        };
        const MODEL_HDR = {
            background: "#374151",
            padding: "8px 14px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderRadius: "8px 8px 0 0"
        };
        const MODEL_SECTION = {
            borderLeft: "1px solid #cbd5e1",
            borderRight: "1px solid #cbd5e1"
        };
        const MODEL_BODY_SECTION = {
            borderLeft: "1px solid #cbd5e1",
            borderRight: "1px solid #cbd5e1",
            borderBottom: "1px solid #cbd5e1",
            borderRadius: "0 0 8px 8px",
            padding: "16px",
            background: "white"
        };

        const hasData = (this.props.twoAfcData?.twoAfcData?.participantChoices?.length ?? 0) > 0;

        return (
            <div style={{width: "100%", marginTop: "20px"}}>
                <table style={{border: "1px lightgray solid", width: "100%"}}>
                    <thead>
                    <tr style={{height: "40px", background: "lightgray"}}>
                        <th style={{paddingLeft: "20px"}}>
                            <span>{this.state.twoAfcData.name || "2AFC"}</span>
                            <Link to={"#"}>
                                        <span title="Delete graph"
                                              className="glyphicon glyphicon-trash"
                                              style={{float: "right", marginRight: "15px", marginTop: "2px"}}
                                              onClick={this.handleDelete}/>
                            </Link>
                            <Link to={"#"}>
                                { this.state.twoAfcData.pinnedToDashboard ?
                                    <span title="Remove this graph from details dashboard"
                                          className="glyphicon glyphicon-bookmark"
                                          style={{float:"right", marginRight:"15px", marginTop:"2px", color:"darkred"}}
                                          onClick={this.removeFromDashboard} /> :
                                    <span title="Show this graph in details dashboard"
                                          className="glyphicon glyphicon-bookmark"
                                          style={{float:"right", marginRight:"15px", marginTop:"2px"}}
                                          onClick={this.addToDashboard} />
                                }
                            </Link>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td style={{padding: "20px", maxWidth: 0}}>
                            {!hasData ? (
                                <div style={{
                                    padding: "14px 18px",
                                    background: "#fffbeb",
                                    border: "1px solid #fde68a",
                                    borderRadius: "6px",
                                    textAlign: "center",
                                    fontSize: "13px",
                                    color: "#92400e"
                                }}>
                                    <strong>No data available.</strong>
                                </div>
                            ) : (<>

                            <div style={CARD}>
                                <div style={CARD_HEADER}>
                                    <h3 style={CARD_TITLE}>Overview &amp; Data Summary</h3>
                                </div>
                                <div style={{ ...CARD_BODY, ...SECTION_LAST }}>
                                    <div style={{ display: "flex", gap: "16px", alignItems: "flex-start", flexWrap: "wrap" }}>
                                        <div style={{ minWidth: 0, overflowX: "auto" }}>
                                            <DatasetSummary data={this.props.twoAfcData}/>
                                        </div>
                                        <div style={{ minWidth: 0, overflowX: "auto" }}>
                                            <Heatmap data={this.props.twoAfcData}/>
                                        </div>
                                    </div>
                                    <RawData data={this.props.twoAfcData}/>
                                </div>
                            </div>

                            <div style={CARD}>
                                <div style={CARD_HEADER}>
                                    <h3 style={CARD_TITLE}>Model Selection</h3>
                                </div>

                                <div style={{ ...SECTION_LAST, padding: "16px 20px", background: "#f8fafc" }}>
                                    <div style={{ display: "flex", gap: "16px", alignItems: "flex-start", flexWrap: "wrap" }}>

                                        <div style={MODEL_CARD}>
                                            <div style={MODEL_HDR}>
                                                <h4 style={{ margin: 0, color: "white", fontSize: "14px", fontWeight: "600" }}>Bradley–Terry Model</h4>
                                            </div>
                                            <div style={{ ...MODEL_SECTION, padding: "6px 14px", background: "#f9fafb", borderBottom: "1px solid #e5e7eb", fontSize: "11px", color: "#4b5563" }}>
                                                <strong style={{ color: "#1e293b" }}>Logistic model:</strong> P(i &gt; j) = 1 / (1 + e<sup>β<sub>j</sub>-β<sub>i</sub></sup>).
                                                Stable and easy to interpret, recommended for most datasets.
                                            </div>
                                            <div style={MODEL_BODY_SECTION}>
                                                <button
                                                    onClick={() => {
                                                        const next = !this.state.showBt;
                                                        sessionStorage.setItem(`2afc_showBt_${this.props.twoAfcData.id}`, next);
                                                        this.setState({ showBt: next });
                                                    }}
                                                    style={{
                                                        padding: "5px 14px",
                                                        fontSize: "12px",
                                                        fontWeight: "600",
                                                        border: "1px solid #cbd5e1",
                                                        borderRadius: "6px",
                                                        background: this.state.showBt ? "#374151" : "white",
                                                        color: this.state.showBt ? "white" : "#374151",
                                                        cursor: "pointer",
                                                        boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                                                        transition: "background 0.15s, color 0.15s",
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        gap: "6px"
                                                    }}
                                                >
                                                    <span style={{ fontSize: "10px" }}>{this.state.showBt ? "▲" : "▼"}</span>
                                                    {this.state.showBt ? "Hide Bradley–Terry Model" : "Generate Bradley–Terry Model"}
                                                </button>
                                                {this.state.showBt && (
                                                    <>
                                                        <div style={{ overflowX: "auto" }}><ResultsTable data={this.props.twoAfcData} modelType="BT" /></div>
                                                        <div style={{ overflowX: "auto" }}><PValueMatrix data={this.props.twoAfcData} modelType="BT" /></div>
                                                        <div style={{ overflowX: "auto" }}><Barchart data={this.props.twoAfcData} modelType="BT" /></div>
                                                        <div style={{ overflowX: "auto" }}><BarchartQualityScore data={this.props.twoAfcData} modelType="BT" /></div>
                                                        <div style={{ overflowX: "auto" }}><PairwiseDiagram data={this.props.twoAfcData} modelType="BT" /></div>
                                                        <div style={{ overflowX: "auto" }}><ResidualPlot data={this.props.twoAfcData} modelType="BT" /></div>
                                                    </>
                                                )}
                                            </div>
                                        </div>

                                        <div style={MODEL_CARD}>
                                            <div style={MODEL_HDR}>
                                                <h4 style={{ margin: 0, color: "white", fontSize: "14px", fontWeight: "600" }}>Thurstone–Mosteller Model</h4>
                                            </div>
                                            <div style={{ ...MODEL_SECTION, padding: "6px 14px", background: "#f9fafb", borderBottom: "1px solid #e5e7eb", fontSize: "11px", color: "#4b5563" }}>
                                                <strong style={{ color: "#1e293b" }}>Normal model:</strong> P(i &gt; j) = Φ((β<sub>i</sub>-β<sub>j</sub>) / √2).
                                                Best when preference differences between methods are symmetric.
                                            </div>
                                            <div style={MODEL_BODY_SECTION}>
                                                <button
                                                    onClick={() => {
                                                        const next = !this.state.showTm;
                                                        sessionStorage.setItem(`2afc_showTm_${this.props.twoAfcData.id}`, next);
                                                        this.setState({ showTm: next });
                                                    }}
                                                    style={{
                                                        padding: "5px 14px",
                                                        fontSize: "12px",
                                                        fontWeight: "600",
                                                        border: "1px solid #cbd5e1",
                                                        borderRadius: "6px",
                                                        background: this.state.showTm ? "#374151" : "white",
                                                        color: this.state.showTm ? "white" : "#374151",
                                                        cursor: "pointer",
                                                        boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                                                        transition: "background 0.15s, color 0.15s",
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        gap: "6px"
                                                    }}
                                                >
                                                    <span style={{ fontSize: "10px" }}>{this.state.showTm ? "▲" : "▼"}</span>
                                                    {this.state.showTm ? "Hide Thurstone–Mosteller Model" : "Generate Thurstone–Mosteller Model"}
                                                </button>
                                                {this.state.showTm && (
                                                    <>
                                                        <div style={{ overflowX: "auto" }}><ResultsTable data={this.props.twoAfcData} modelType="TM" /></div>
                                                        <div style={{ overflowX: "auto" }}><PValueMatrix data={this.props.twoAfcData} modelType="TM" /></div>
                                                        <div style={{ overflowX: "auto" }}><Barchart data={this.props.twoAfcData} modelType="TM" /></div>
                                                        <div style={{ overflowX: "auto" }}><BarchartQualityScore data={this.props.twoAfcData} modelType="TM" /></div>
                                                        <div style={{ overflowX: "auto" }}><PairwiseDiagram data={this.props.twoAfcData} modelType="TM" /></div>
                                                        <div style={{ overflowX: "auto" }}><ResidualPlot data={this.props.twoAfcData} modelType="TM" /></div>
                                                    </>
                                                )}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            </>)}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default PartTwoAfcPanel;
